<template>
  <v-container fluid>
    <material-card
    color="primary"
    :title="$t('products')"
    full-width >

      <v-tabs v-model="currentTab">
        <v-tab>{{$t('products')}}</v-tab>
        <v-tab>{{$t('species')}}</v-tab>
        <v-tab>{{$t('grades')}}</v-tab>
        <v-tab>{{$t('endUseSorts')}}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab" touchless>
        <v-tab-item>
          <ProductSettings/>
        </v-tab-item>

        <v-tab-item>
          <SpeciesSettings/>
        </v-tab-item>

        <v-tab-item>
          <GradeSettings/>
        </v-tab-item>

        <v-tab-item>
          <EndUseSortSettings/>
        </v-tab-item>
      </v-tabs-items>

    </material-card>
  </v-container>
</template>

<script>
export default {
  name: 'ProductSettingsTabs',

  components: {
    ProductSettings: () => import('./product/ProductSettings.vue'),
    SpeciesSettings: () => import('./species/SpeciesSettings.vue'),
    GradeSettings: () => import('./grade/GradeSettings.vue'),
    EndUseSortSettings: () => import('./end-use-sort/EndUseSortSettings.vue')
  },

  data: () => ({
    currentTab: 0
  })
}
</script>
